module.exports = __webpack_public_path__ + "img/growth1.f5586894.png";